import styled, { keyframes } from 'styled-components'

import { SpacingClass } from './enum'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const ComponentStructure = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  animation: ${fadeIn} 0.2s ease-in-out;
  z-index: 9999;
`

export const Content = styled.div<{ spacingClass: SpacingClass }>`
  position: absolute;
  background: white;
  width: 600px;
  border-radius: 6px;
  padding: ${({ theme, spacingClass }) =>
      theme.informationCard[spacingClass]?.verticalSpacing}px
    ${({ theme, spacingClass }) =>
      theme.informationCard[spacingClass]?.horizontalSpacing}px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    margin: 16px;
    width: auto;
  }
`

export const HeaderStructure = styled.div<{ spacingClass: SpacingClass }>`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme, spacingClass }) =>
    theme.informationCard[spacingClass]?.headerSpacingBottom}px;
`

export const Title = styled.h4<{ spacingClass: SpacingClass }>`
  font-size: ${({ theme, spacingClass }) =>
    theme.informationCard[spacingClass]?.titleSize}px;
  font-weight: bold;
  margin: 0;
  margin-right: ${({ theme, spacingClass }) =>
    theme.informationCard[spacingClass]?.titleRightSpacing}px;
`

export const CloseButtonStructure = styled.button<{
  spacingClass: SpacingClass
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: solid 3px ${({ theme }) => theme.colors._006BFF};
  background: transparent;
  width: ${({ theme, spacingClass }) =>
    theme.informationCard[spacingClass]?.headerCardHeight}px;
  height: ${({ theme, spacingClass }) =>
    theme.informationCard[spacingClass]?.headerCardHeight}px;
`
